export default {
  async contactSkipper(context, payload) {
    const newRequest = {
      userEmail: payload.email,
      message: payload.message
    };

    const response = await fetch(
      `https://vue-http-demo-6781e-default-rtdb.firebaseio.com/requests/${payload.skipperId}.json`,
      {
        method: 'POST',
        body: JSON.stringify(newRequest)
      }
    );

    const data = await response.json();

    if (!response.ok) {
      const error = new Error(data.message || 'Failed to send request');
      throw error;
    }

    //new id property is added, response data object will have
    //a name field which holds this automatically generated id.

    newRequest.id = data.name;
    newRequest.skipperId = payload.skipperId;

    context.commit('addRequest', newRequest);
  },

  async fetchRequests(context) {
    const skipperId = context.rootGetters.userId;
    const token = context.rootGetters.token;

    const response = await fetch(
      `https://vue-http-demo-6781e-default-rtdb.firebaseio.com/requests/${skipperId}.json?auth=` +
        token
    );

    const data = await response.json();

    if (!response.ok) {
      const error = new Error(data.message || 'Failed to fetch request');
      throw error;
    }

    const requests = [];

    for (const key in data) {
      const request = {
        id: key,
        skipperId: skipperId,
        userEmail: data[key].userEmail,
        message: data[key].message
      };
      requests.push(request);
    }

    context.commit('setRequests', requests);
  }
};
